module.exports = __webpack_public_path__ + "img/B12-20190411_06.e7a071ec.jpg";